import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

export const supportedLanguages = ['de', 'en', 'tr', 'ru', 'ar', 'pl', 'it', 'ro', 'uk'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

export const languageNames: Record<SupportedLanguage, string> = {
  de: 'Deutsch',
  en: 'English',
  tr: 'Türkçe',
  ru: 'Русский',
  ar: 'العربية',
  pl: 'Polski',
  it: 'Italiano',
  ro: 'Română',
  uk: 'Українська',
};

export const languageFlags: Record<SupportedLanguage, string> = {
  de: '🇩🇪',
  en: '🇬🇧',
  tr: '🇹🇷',
  ru: '🇷🇺',
  ar: '🇸🇦',
  pl: '🇵🇱',
  it: '🇮🇹',
  ro: '🇷🇴',
  uk: '🇺🇦',
};

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    debug: false,
    supportedLngs: supportedLanguages,
    
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    backend: {
      loadPath: '/locales/{{lng}}.json',
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false,
    },
  });

// Set document direction for RTL languages
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
});

export default i18n;